<div class="container mb-5 marginMobile">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-12 col-md-8 col-lg-8 col-xl-10">
            <div class="card p-3">
              <script>

              </script>
              <div class="">
                <div class="container px-0 pb-4">
                  <div class="row">
                    <div class="col-4">
                      <label for="dateDebut" class="filterLabel">Date de début de commande</label>
                      <input type="date" id="dateDebut" class="form-control dateFilter" [(ngModel)]="startDate">
                    </div>
                    <div class="col-4">
                      <label for="dateDebut" class="filterLabel">Date de fin de commande</label>
                      <input type="date" id="dateFin" class="form-control dateFilter" [(ngModel)]="endDate">
                    </div>
                    <div class="col-4">
                      <button class="generatePDF" (click)="filtre()">
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <div class="row">
                    <div class="col-md-12">
                      <input type="text" id="myInput" onkeyup="myFunction()" placeholder="Recherche.." title="Type in a name">
                    </div>
                  </div>
                  <table id="tableBalance" class="table table-striped" style="width:100%">
                    <thead>
                        <tr>
                            <th>Num commande</th>
                            <th>Date commande</th>
                            <th>Montant HT</th>
                            <th>Montant TTC</th>
                            <th>Nombre d'article</th>
                            <!-- <th>Actions</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let commande of listCommandes">
                            <td><a [routerLink]="['/commande-detail', commande.SOHNUM]" >{{commande.SOHNUM}}</a></td>
                            <td>{{commande.ORDDAT | dateform}}</td>
                            <td>{{commande.ORDINVNOT}}</td>
                            <td>{{commande.ORDINVATI}}</td>
                            <td>{{commande.LINNBR}}</td>
                            <!-- <td width="20%">
                              <a [routerLink]="['/commande-detail', commande.SOHNUM]" >
                                <button class="btn btn-detail" type="button" name="button" style="width:100%; margin-bottom:2px;"><i class="fa fa-eye"></i> Détail</button>
                              </a>
                            </td> -->
                        </tr>
                    </tbody>
                  </table>
                </div>
                <div class="dataTables_paginate paging_simple_numbers" id="tableBalance_paginate">
                  <a [routerLink]="['/commandes/', currentPage-1]"  class="paginate_button previous disabled" aria-controls="tableBalance" data-dt-idx="0" tabindex="-1" id="tableBalance_previous" *ngIf="currentPage!=1">Précédent</a>
                  <span>
                    <ng-container *ngFor="let page of pages">
                      <a [routerLink]="['/commandes/', page]" href="/commandes/{{page}}" *ngIf="currentPage - page >= -3 && currentPage - page <= 3  "  class="paginate_button " [ngClass]="{'current': currentPage == page}" aria-controls="tableBalance" data-dt-idx="1" tabindex="0" >{{page}}</a>
                    </ng-container>

                    <!-- <a href="/commandes/{{currentPage}}"   class="paginate_button current" aria-controls="tableBalance" data-dt-idx="1" tabindex="0">{{currentPage}}</a>
                    <a href="/commandes/{{currentPage+1}}" class="paginate_button " aria-controls="tableBalance" data-dt-idx="2" tabindex="0">{{currentPage+1}}</a>
                    <a href="/commandes/{{currentPage+2}}" class="paginate_button " aria-controls="tableBalance" data-dt-idx="3" tabindex="0">{{currentPage+2}}</a>
                    <a href="/commandes/{{currentPage+3}}" class="paginate_button " aria-controls="tableBalance" data-dt-idx="4" tabindex="0">{{currentPage+3}}</a>
                    <a href="/commandes/{{currentPage+4}}" class="paginate_button " aria-controls="tableBalance" data-dt-idx="5" tabindex="0">{{currentPage+4}}</a> -->
                    <span class="ellipsis" *ngIf="nbrPages!=currentPage">…</span>
                    <a [routerLink]="['/commandes/', nbrPages]"  *ngIf="nbrPages!=currentPage" class="paginate_button " aria-controls="tableBalance" data-dt-idx="6" tabindex="0">{{nbrPages}}</a>
                  </span>
                  <a [routerLink]="['/commandes/', currentPage+1]"  class="paginate_button next" aria-controls="tableBalance" data-dt-idx="7" tabindex="0" id="tableBalance_next" *ngIf="nbrPages!=currentPage">Suivant</a>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
